<template>
  <!-- // Hidden telephony chagers for PoC -->
  <!-- 
    - Agregado atributo "style" a la card
    - Chart de SMS comentado
    - Cambio de height del chart de whatsapp en su atributo y en chartOptions1 (original: 150)
  -->

  <dashboard-chart-card
    style="height: 100%"
    title="Resumen de telefonia"
    @handleDownloadClick="$emit('handleDownload')"
  >
    <template #info>
      <a-popover
        trigger="hover"
        class="popover"
        placement="bottomRight"
        :overlayStyle="{ width: '250px' }"
      >
        <template #title>
          <span class="titlePopover"> Resumen de telefonía </span>
        </template>
        <template #content>
          <div class="content">
            Cantidad y gastos de llamadas por horas.
            <a href="http://securitec.pe" target="_blank" rel="noopener noreferrer">Click aquí</a>
            para ver los precios de destino.
          </div>
        </template>
        <InfoCircleOutlined class="info-circle" />
      </a-popover>
    </template>

    <a-row>
      <a-col :span="24">
        <apexcharts
          height="310"
          type="line"
          :options="chartOptions1"
          :series="totalCallsSeries"
        ></apexcharts>
      </a-col>
      <!-- <a-col :span="24">
        <apexcharts
          height="150"
          type="line"
          :options="chartOptions2"
          :series="telephoneChargesSeries"
        ></apexcharts>
      </a-col> -->
    </a-row>
  </dashboard-chart-card>
</template>

<script>
import { defineComponent } from "vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";
import VueApexCharts from "vue3-apexcharts";
import _ from "lodash";
import dayjs from "dayjs";

import { dateTimeToSlashFormat } from "@/app/shared/utils/dates";

import DashboardChartCard from "../cards/DashboardChartCard.vue";

export default defineComponent({
  components: {
    DashboardChartCard,
    apexcharts: VueApexCharts,
    InfoCircleOutlined,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    hourRange: {
      required: true,
      type: Object,
    },
  },
  computed: {
    totalCalls() {
      const sortedData = _.sortBy(this.data?.total_calls, ["date", "hour", "count"]);

      const hourRangeArray = Object.keys(this.hourRange).map((hour) => Number(hour));

      if (hourRangeArray.length !== 0) {
        const formattedHourRange = hourRangeArray.map((hour) => ({ hour, count: 0 }));

        sortedData.forEach((callData) => {
          const callHour = dayjs(callData?.date).hour();

          const idx = formattedHourRange.findIndex(({ hour }) => hour === callHour);

          const { count } = callData;
          const newCallData = { hour: callHour, count };

          formattedHourRange[idx] = newCallData;
        });

        return formattedHourRange;
      }

      return sortedData;
    },
    totalCallsCategories() {
      return this.totalCalls?.map((value) =>
        value.date ? dateTimeToSlashFormat(value.date, false) : value.hour + ":00hrs"
      );
    },
    totalCallsSeries() {
      if (this.totalCalls)
        return [{ data: this.totalCalls.map((value) => Number(value.count)?.toFixed(1)) }];
      else return [{ data: [] }];
    },
    telephoneCharges() {
      return _.sortBy(this.data?.telephone_charges, ["date", "hour", "amount"]);
    },
    telephoneChargesCategories() {
      return this.telephoneCharges?.map((value) =>
        value.date ? value.date : value.hour + ":00hrs"
      );
    },
    telephoneChargesSeries() {
      if (this.telephoneCharges)
        return [{ data: this.telephoneCharges.map((value) => value.amount) }];
      else return [{ data: [] }];
    },
    chartOptions1() {
      return {
        chart: {
          type: "line",
          height: 310,
          zoom: {
            autoScaleYaxis: true,
          },
          toolbar: {
            show: false,
          },
        },
        stroke: {
          width: 2,
          curve: "straight",
        },
        colors: ["#91D5FF"],
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 0,
          style: "hollow",
        },
        yaxis: {
          title: {
            text: "Cantidad de minutos",
          },
        },
        xaxis: {
          categories: this.totalCallsCategories,
        },
        tooltip: {
          custom: function ({ series, seriesIndex, dataPointIndex }) {
            return `<div class="arrow_box">
              <span> 
                ${series[seriesIndex][dataPointIndex]} 
              </span> 
              </div>`;
          },
        },
      };
    },
    chartOptions2() {
      return {
        chart: {
          type: "line",
          height: 150,
          zoom: {
            autoScaleYaxis: true,
          },
          toolbar: {
            show: false,
          },
        },
        stroke: {
          width: 2,
          curve: "straight",
        },
        colors: ["#91D5FF"],
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 0,
          style: "hollow",
        },
        yaxis: {
          title: {
            text: "Gastos de telefonía($)",
          },
        },
        xaxis: {
          categories: this.telephoneChargesCategories,
        },
        tooltip: {
          custom: function ({ series, seriesIndex, dataPointIndex }) {
            return (
              '<div class="arrow_box">' +
              "<span>" +
              series[seriesIndex][dataPointIndex] +
              "</span>" +
              "</div>"
            );
          },
        },
      };
    },
  },
});
</script>

<style>
.arrow_box {
  padding: 2px 8px;
  border-radius: 5px;
  background: #91d5ff;
  font-size: 12px;
  text-align: center;
  display: flex;
  justify-content: center;
}
</style>

<style lang="sass" scoped>
.popover
  margin-right: 20px

.info-circle
  font-size: 14px
  color: #51555A

.content
  font-weight: 300
  color: $gray-8

.titlePopover
  font-size: 16px
  font-weight: 600
</style>
